export const SOFT_HYPHEN_SYMBOL = "¶";
